// Web Push di browser: berlangganan notifikasi yang tetap muncul (dengan suara/getar sistem) walau tab/browser ditutup.
// Syarat browser: HTTPS atau localhost (konteks aman), dan pengguna mengizinkan notifikasi. iPhone/iPad hanya jika situs
// dipasang ke layar utama (PWA). Server: backend /webpush/* (utils/webPush.js). Salinan identik ada di menu/src/utils/webPush.js.
import axios from 'axios';

export const webPushDidukung = () =>
  typeof window !== 'undefined' && window.isSecureContext && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

const urlBase64ToUint8Array = (b64) => {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const daftarkanSw = async () => {
  const reg = await navigator.serviceWorker.register('/sw-push.js');
  await navigator.serviceWorker.ready;
  return reg;
};

/** { didukung, izin: 'default'|'granted'|'denied', aktif } untuk browser ini. */
export const statusWebPush = async () => {
  if (!webPushDidukung()) return { didukung: false, izin: 'denied', aktif: false };
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    return { didukung: true, izin: Notification.permission, aktif: !!sub && Notification.permission === 'granted' };
  } catch (_) {
    return { didukung: true, izin: Notification.permission, aktif: false };
  }
};

/**
 * Aktifkan notifikasi. jenis 'staf' (login, notifikasi pesanan baru cabang) atau 'pelanggan' (butuh orderId).
 * Harus dipanggil dari klik pengguna (izin notifikasi hanya bisa diminta lewat gerakan pengguna).
 * Melempar Error berisi pesan yang bisa ditampilkan.
 */
export const aktifkanWebPush = async ({ apiBase, jenis = 'staf', orderId }) => {
  if (!webPushDidukung()) throw new Error('Browser ini tidak mendukung notifikasi (butuh HTTPS atau localhost).');
  const izin = await Notification.requestPermission();
  if (izin !== 'granted') throw new Error('Izin notifikasi ditolak. Ubah di pengaturan situs browser untuk mengaktifkannya.');
  const reg = await daftarkanSw();
  const { data } = await axios.get(`${apiBase}/webpush/kunci`);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.publicKey) });
  const subscription = sub.toJSON();
  if (jenis === 'pelanggan') {
    await axios.post(`${apiBase}/webpush/langganan-pelanggan`, { subscription, orderId });
  } else {
    await axios.post(`${apiBase}/webpush/langganan`, { subscription }, { withCredentials: true });
  }
  return true;
};

export const matikanWebPush = async ({ apiBase }) => {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    if (sub) {
      const endpoint = sub.endpoint;
      await sub.unsubscribe();
      await axios.post(`${apiBase}/webpush/berhenti`, { endpoint });
    }
  } catch (_) { /* tidak apa-apa */ }
};
